import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values  = { active: { type: String, default: "" } }

  connect() {
    this.show(this.activeValue || this.tabTargets[0]?.dataset.tab)
  }

  switch(event) {
    event.preventDefault()
    this.show(event.currentTarget.dataset.tab)
  }

  show(name) {
    this.tabTargets.forEach(tab => {
      const active = tab.dataset.tab === name
      tab.setAttribute("aria-selected", active)
      tab.setAttribute("tabindex", active ? "0" : "-1")
      tab.classList.toggle("border-blue-600", active)
      tab.classList.toggle("text-blue-600",  active)
      tab.classList.toggle("border-transparent", !active)
      tab.classList.toggle("text-gray-600",  !active)
    })
    this.panelTargets.forEach(panel => {
      panel.hidden = panel.dataset.panel !== name
    })
  }
}
